import { useEffect, useState } from 'react';

export type UseFetchOptions = {
  defaultData?: unknown;
  fetcher: (payload: any) => Promise<unknown>;
  stopRequest?: boolean;
  immediately?: boolean;
  onSuccess?: (response: any) => void;
  onError?: (err: any) => void;
};

export const useFetch = <T = any>(
  {
    defaultData = null,
    fetcher,
    stopRequest,
    immediately,
    onSuccess,
    onError,
  }: UseFetchOptions,
  payload: any,
  triggers: any[] = [],
) => {
  const initialState = {
    loading: immediately,
    error: null as any,
    data: defaultData as T,
  };

  const [{ loading, error, data }, setState] = useState(initialState);

  const fetchData = () => {
    if (stopRequest) {
      return;
    }

    if (!loading) {
      setState((state: any) => ({
        ...state,
        loading: true,
      }));
    }

    fetcher(payload)
      .then((response: any) => {
        setState({
          loading: false,
          error: null,
          data: response as T,
        });

        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((err: any) => {
        setState((state: any) => ({
          ...state,
          loading: false,
          error: err,
        }));

        if (onError) {
          onError(err);
        }
      });
  };

  useEffect(fetchData, [stopRequest, ...triggers]);

  return { loading, error, data: data as T, setState };
};
